import styled from "styled-components";
import * as h from "../../_themes/helpers";
import { BaseButton } from "../../BaseButton";

export const Wrapper = styled(BaseButton)`
  color: ${h.getColor("button")};
  border-radius: 50%;
  display: inline-block;

  &:active {
    color: ${h.getPressedColor("button")};
  }

  &[disabled] {
    color: ${h.getDisabledColor("button")};
  }
`;
